import React from 'react';
import { makeStyles,  createStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { changeLang, Lang } from '../../states/query';

const useStyles = makeStyles(() =>
  createStyles({
    subtitle: {
      textDecoration: 'underline'
    },
    annotation: {
      fontSize: '12px',
    }
  }),
);

const TaxiServiceAboutBody: React.FC = () => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const lang = changeLang(i18n.language);

  const JPBody: React.FC = () => {
    return (
      <div>
        <h3 className={classes.subtitle}>このサービスについて</h3>
        <p>メールによるハイヤー・タクシー配車予約サービスです。ご利用空港およびご利用航空便にあわせて、地図上で選択いただいた「指定地点から空港まで」「空港から指定地点まで」のハイヤー・タクシーの配車予約が可能です。</p>
        <p className={classes.annotation}>※提携のハイヤー・タクシー会社は順次拡大してまいります。</p>
        <h3 className={classes.subtitle}>推奨環境</h3>
        <p>●PC・スマートフォン（ブラウザ）</p>
        <p>Google chrome（最新版）</p>
        <p>Safari(最新版)</p>
        <p>●スマートフォン（OS）</p>
        <p>iOS11以降</p>
        <p>Android5.0以降</p>
        <h3 className={classes.subtitle}>所要距離および所要時間の概算表示について</h3>
        <p>地図で選択いただいた座標をもとに想定走行距離および想定所要時間を算出しております。所要時間の取得には、ハイヤー・タクシーのご乗車予定時刻を起点とした混雑予想を加味して所要時間を表示しておりますが、道路事情等により実際と異なる場合がございますのでご注意ください。</p>
        <p>※地図情報提供元：Google</p>
      </div>
    );
  }

  const EnBody: React.FC = () => {
    return (
      <div>
        <h3 className={classes.subtitle}>About this service</h3>
        <p>This is a limousine and taxi dispatch booking service based on email. You can book a limousine or taxi dispatch “to the airport from your specified location” or “from the airport to your specified location” as selected on a map, based on the airport and airline you are using. </p>
        <p className={classes.annotation}>* Partnerships with limousine and taxi dispatch service companies will be expanded successively.</p>
        <h3 className={classes.subtitle}>Recommended environment</h3>
        <p>PC / smartphone (browser)</p>
        <p>Google Chrome (latest version)</p>
        <p>Safari (latest version)</p>
        <p>Smartphone (OS)</p>
        <p>iOS 11 or later</p>
        <p>Android 5.0 or later</p>
        <h3 className={classes.subtitle}>About shown estimate of travel distance and time</h3>
        <p>The system calculates the estimated driving distance and travel time based on the coordinates you select on the map. To obtain and show the travel time, the system factors in predicted congestion based on the time the limousine taxi is booked for. However, please keep in mind that it may differ from the actual travel time due to the road situation, etc.</p>
        <p>* Source of map information: Google</p>
      </div>
    );
  }

  switch(lang) {
    case Lang.en:
      return <EnBody/>
    case Lang.ja:
      return <JPBody/>
  }

}

export default TaxiServiceAboutBody;
